import { createFileRoute, redirect } from '@tanstack/react-router';

import { EsgSectionPage } from '@/features/esg/components/EsgSectionPage';
import { getEsgSection, isEsgSection } from '@/features/esg/config';

export const Route = createFileRoute('/_authenticated/esg/$section')({
  beforeLoad: ({ params }) => {
    if (!isEsgSection(params.section)) {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/esg/overview' });
    }

    return {
      getTitle: () => getEsgSection(params.section).title,
    };
  },
  component: EsgSectionRoute,
});

function EsgSectionRoute() {
  const { section } = Route.useParams();

  if (!isEsgSection(section)) {
    return null;
  }

  return <EsgSectionPage sectionId={section} />;
}
